import { createStore, applyMiddleware, compose } from 'redux';
import createReducer from './reducers';

import savedSearchesReducer from './reducers/savedSearches';
import lastSearchReducer from './reducers/lastSearch';
import testDenominationsReducer from './reducers/testDenominations';
import notificationsReducer from './reducers/notifications';

const composeEnhancers = (window as any)['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose || compose;

export function configureStore() {
  const middlewares: any[] = [];
  const store = createStore(
    createReducer({
      savedSearches: savedSearchesReducer,
      lastSearch: lastSearchReducer,
      testDenominations: testDenominationsReducer,
      notifications: notificationsReducer
    }),
    {},
    composeEnhancers(applyMiddleware(...middlewares))
  );
  return store;
}

export default configureStore;
